<template>

  <tr
    @click="$router.push('/rhevolut/jobs/123')"
    class="table-tr-pointer">
    <td style="padding: 15px;">
      <h5 class="mb-1">
      <router-link
        style="color: inherit;"
        to="/rhevolut/jobs/123">{{ bucket.title }}</router-link>
      </h5>
      <div>
        Criado em {{ bucket.created_at }}
      </div>
      <RhevolutJobListForm
        v-if="modal_select"
        :initValue="modal_select" 
        @hideModal="hideModal()"
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()" />
    </td>
    <td style="vertical-align: middle;">
      <div style="font-size: 18px;">
        <router-link to="/rhevolut/jobs/123" style="color: inherit;">
          {{ bucket.matchs_total  }} matchs
        </router-link>
      </div>
    </td>
    <td style="vertical-align: middle;">
      <div>
        <span style="font-size: 18px;">
          <router-link to="/rhevolut/jobs/123/considered" style="color: inherit;">
            {{ bucket.analyzing_total }} Pré-selecionados
          </router-link>
        </span>
      </div>
    </td>
    <td style="vertical-align: middle;">
      <div>
        <span style="font-size: 18px;">
          <router-link to="/rhevolut/jobs/123/applied" style="color: inherit;">
            {{ bucket.applied_total }} aplicados
          </router-link>
        </span>
        <span class="badge badge-danger">{{ bucket.new_total }} novos</span>
      </div>
    </td>
    <td  style="vertical-align: middle; text-align: right;" @click="$event.stopPropagation()">
      <div class="btn-group">
        <button class="btn btn-secondary" type="button">
          {{ bucket.status }}
        </button>
        <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false">
          <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu">
          <a class="dropdown-item" href="#">Publicar</a>
          <a class="dropdown-item" href="#">Abrir</a>
          <a class="dropdown-item" href="#">Arquivar</a>
        </div>
      </div>
      <button
        @click="modal_select = {}"
        class="btn btn-ligth"
        type="button">
        <i class="fa-solid fa-gear"></i>
      </button>
    </td>
  </tr>

</template>

<script>
import RhevolutJobListForm from './RhevolutJobListForm'
export default {
  name: 'JobRhevolutItem',
  components: {
    RhevolutJobListForm
  },
  props: {
    bucket: {
      type: Object,
      value: () => { return {} }
    }
  },
  data () {
    return {
      modal_select: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {
        type: this.modelType
      }
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.skills {
  display: flex;
  flex-wrap: wrap;
}
.skills > * {
  margin: 0.1em;
  padding: 0.3em 0.8em;
  border-radius: 2em;
}

.bucket-item {
  display: flex;
  justify-content: space-between;
}
  .bucket-item > * {
  }
  .bucket-item > *.actions {
    text-align: center;
  }
.circle {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: #333;
}
  .circle::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: conic-gradient(#28a745 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
    -webkit-mask: radial-gradient(circle, transparent 52%, white 53%);
            mask: radial-gradient(circle, transparent 52%, white 53%);
  }
  .circle.circle-success::before {
    background: conic-gradient(#28a745 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
  }
  .circle.circle-primary::before {
    background: conic-gradient(#007bff calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
  }
  .circle.circle-warning::before {
    background: conic-gradient(#ffc107 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%)) !important;
  }
  .circle-content {
    position: relative;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJobList/RhevolutJobListItem.vue